import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Skeleton — uses the shared `.skeleton-shimmer` background defined in
 * styles/globals.css and the `animate-shimmer` keyframe registered in
 * tailwind.config.ts. Default radius is `rounded-sm` to match `.ez-skel`.
 */
export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        aria-hidden="true"
        className={cn('skeleton-shimmer animate-shimmer rounded-sm', className)}
        {...props}
      />
    );
  },
);
Skeleton.displayName = 'Skeleton';
